import { faTruckRampCouchSolid } from '@/lib/fa'
import ActivityItem from '@/modules/drivers/forms/activities/components/ActivityItem'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { useRaportForm } from '@/modules/printouts/context/RaportFormContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'

const EntryType = () => {
  const { data, setData } = useRaportForm()
  const { t } = useLocalize()

  return (
    <div className="tw-flex tw-justify-between">
      <div className="tw-flex tw-flex-1 tw-items-start tw-gap-2 tw-font-medium tw-text-content-base">
        <StageHeader
          title={t('printout.entry-type')}
          textSize="sm"
          icon={faTruckRampCouchSolid}
        />

        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
          <ActivityItem
            onClick={() =>
              setData({
                ...data,
                manualEntry: !data.manualEntry,
                manualEntryEnabled: !data.manualEntryEnabled,
              })
            }
            label={t('printout.manual-entry')}
            checked={data.manualEntry || data.manualEntryEnabled || false}
          />
          <ActivityItem
            onClick={() =>
              setData({
                ...data,
                outOfScope: !data.outOfScope,
                outOfScopeEnabled: !data.outOfScopeEnabled,
              })
            }
            checked={data.outOfScopeEnabled || data.outOfScope || false}
            label={t('printout.out-of-scope')}
          />{' '}
          <ActivityItem
            onClick={() =>
              setData({
                ...data,
                crewEnabled: !data.crewEnabled,
                crew: !data.crew,
              })
            }
            label={t('printout.crew')}
            checked={data.crewEnabled || data.crew || false}
          />{' '}
          <ActivityItem
            onClick={() =>
              setData({
                ...data,
                ferryTrainCrossing: !data.ferryTrainCrossing,
                ferryTrainCrossingEnabled: !data.ferryTrainCrossingEnabled,
              })
            }
            label={t('printout.ferry')}
            checked={
              data.ferryTrainCrossingEnabled || data.ferryTrainCrossing || false
            }
          />
        </div>
      </div>
    </div>
  )
}

export default EntryType
